export const FLAGS_API_URL =
    "https://purecatamphetamine.github.io/country-flag-icons/3x2" //https://www.npmjs.com/package/country-flag-icons

export const CHAPERON_API_URL = import.meta.env.VITE_CHAPERON_API_URL

// The marketing site's app download section, for the "Go mobile" banner.
export const GET_CHAPERON_APP_URL = "https://getchaperon.com/#access"

// Share links go to chaperon.app (the chaperon-app service), which unfurls
// them with the place's safety-level card. See docs/SHARE_LINKS.md.
export const CHAPERON_SHARE_URL = (
    globalThis.window?._env_?.VITE_CHAPERON_SHARE_URL ||
    import.meta.env.VITE_CHAPERON_SHARE_URL ||
    "https://chaperon.app"
).replace(/\/$/, "")
